import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { RouteSeo } from "./RouteSeo";
import { trackConversion } from "../lib/analytics";

export function Layout() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
    else {
      let frame = 0;
      let attempts = 0;
      const findTarget = () => {
        const target = document.getElementById(decodeURIComponent(hash.slice(1)));
        if (target) target.scrollIntoView();
        else if (attempts++ < 180) frame = requestAnimationFrame(findTarget);
      };
      findTarget();
      return () => cancelAnimationFrame(frame);
    }
  }, [pathname, hash]);

  useEffect(() => {
    const trackLink = (event: MouseEvent) => {
      if (event.type === "auxclick" && event.button !== 1) return;
      const link = (event.target as Element)?.closest?.("a[href]") as HTMLAnchorElement | null;
      if (!link) return;
      const url = new URL(link.href);
      const location = link.closest<HTMLElement>("[data-track-location]")?.dataset.trackLocation ?? "page";
      if (url.hostname === "wa.me") trackConversion("whatsapp_click", location);
      else if (url.origin === window.location.origin && /^\/start-project\/?$/.test(url.pathname)) trackConversion("sourcing_request_click", location);
    };
    document.addEventListener("click", trackLink);
    document.addEventListener("auxclick", trackLink);
    return () => { document.removeEventListener("click", trackLink); document.removeEventListener("auxclick", trackLink); };
  }, []);

  return (
    <div className="flex min-h-screen flex-col selection:bg-brand-lime selection:text-brand-dark">
      <a href="#main-content" className="fixed left-4 top-4 z-[100] -translate-y-24 rounded-sm bg-brand-lime px-4 py-3 font-semibold text-brand-dark transition-transform focus:translate-y-0">
        Skip to main content
      </a>
      <RouteSeo />
      <Navbar />
      <main id="main-content" tabIndex={-1} className="flex-1 focus:outline-none">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
